// @flow
import * as React from 'react';

import { withTranslation } from '@i18n';

import { Carousel } from 'react-responsive-carousel';
import NewPatientUpload from './newPatientDocumentUpload';
import { StyledContentTop, StyledInterviewWrapper, StyledCover } from './styles/details';
import type { PropsTreatmentPage } from './types';

import { StyledCard } from './styles';

import Details from './Details';

const TreatmentFlow = ({
  handleTimeSelect,
  slide,
  success,
  isMobile,
  propsDetails,
  treatmentPage,
  executeScroll,
  CarouselProps,
  doctor,
  hospital,
  setSuccess,
  formName
}: PropsTreatmentPage) => (
  <Carousel {...CarouselProps} selectedItem={slide}>
    {!formName ? (
      <StyledCard>
        <StyledCover formName={formName}>
          <StyledContentTop formName={formName}>
            <StyledInterviewWrapper>
              <Details
                isMobile={isMobile}
                isActive={slide === 0}
                {...propsDetails}
                setSuccess={setSuccess}
                clickEvent={executeScroll}
                treatmentPage={treatmentPage}
                onTimeSelect={handleTimeSelect}
                formName={formName}
                doctor={doctor}
              />

              <NewPatientUpload
                slide={slide}
                success={success}
                isActive={slide === 2 || slide === 3}
                setSuccess={setSuccess}
                formName="FinderForm"
                onTimeSelect={handleTimeSelect}
                treatmentFormName={formName}
              />
            </StyledInterviewWrapper>
          </StyledContentTop>
        </StyledCover>
      </StyledCard>
    ) : (
      <>
        <Details
          isMobile={isMobile}
          isActive={slide === 0}
          {...propsDetails}
          setSuccess={setSuccess}
          clickEvent={executeScroll}
          treatmentPage={treatmentPage}
          onTimeSelect={handleTimeSelect}
          formName={formName}
          doctor={doctor}
          hospital={hospital}
        />

        <NewPatientUpload
          slide={slide}
          success={success}
          isActive={slide === 1 || slide === 2}
          setSuccess={setSuccess}
          formName="FinderForm"
          onTimeSelect={handleTimeSelect}
          treatmentFormName={formName}
        />
      </>
    )}
  </Carousel>
);

TreatmentFlow.getInitialProps = (): {} => ({
  namespacesRequired: ['HowItWorksScreen']
});

export default withTranslation('HowItWorksScreen')(TreatmentFlow);
